import Icons from '@datacloud-incubation/frontend-icons-module';

const ROUTER_PATH = {
  base: '/',
  notFound: '*',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  flows: '/flows',
  viewFlow: '/flows/:id',
  editFlow: '/flows/:id/edit',
  flowChat: '/flows/:id/chat',
  connections: '/connections',
  viewConnection: '/connections/:category/:id',
  editConnection: '/connections/:category/:id/edit',
  users: '/users',
  viewUser: '/users/:id',
  editUser: '/users/:id/edit',
  apiUsers: '/api-users',
  viewApiUser: '/api-users/:id',
  editApiUser: '/api-users/:id/edit',
  roles: '/roles',
  viewRole: '/roles/:id',
  editRole: '/roles/:id/edit',
  viewProfile: '/profile/view',
  editProfile: '/profile/edit',
  logs: '/user-action-logs'
} as const;

const ROUTER_ITEMS = {
  [ROUTER_PATH.flows]: {
    path: ROUTER_PATH.flows,
    title: 'Flows',
    icon: <Icons.IconObjectTable />
  },
  [ROUTER_PATH.connections]: {
    path: ROUTER_PATH.connections,
    title: 'Connections',
    icon: <Icons.IconDatabasesRoot />
  },
  [ROUTER_PATH.users]: {
    path: ROUTER_PATH.users,
    title: 'Users',
    icon: <Icons.IconUser />
  },
  [ROUTER_PATH.apiUsers]: {
    path: ROUTER_PATH.apiUsers,
    title: 'API-Users',
    icon: <Icons.IconDbUserDefinedType />
  },
  [ROUTER_PATH.roles]: {
    path: ROUTER_PATH.roles,
    title: 'User Roles',
    icon: <Icons.IconPageBuilderPageRole />
  },
  [ROUTER_PATH.logs]: {
    path: ROUTER_PATH.logs,
    title: 'User Action Logs',
    icon: <Icons.IconLogs />
  }
} as const;

export { ROUTER_ITEMS, ROUTER_PATH };
